import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ErrorFallback } from './components/ErrorFallback/ErrorFallback';
import history from './helpers/history';
import { LayoutProvider, LayoutSplashScreen } from './layout/core';
import { Routes } from './routing/Routes';

function App() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router history={history}>
          <LayoutProvider>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              limit={1}
            />
            <Routes />
          </LayoutProvider>
        </Router>
      </ErrorBoundary>
    </Suspense>
  );
}

export default App;
